import {useState, useEffect, useMemo} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createSCAPIFetch} from '../utills/customFetch'

const useCustomFetch = (token, ids) => {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const {app: appConfig} = getConfig()
    const slotParams = useMemo(() => `ids=${ids}`, [ids])

    useEffect(() => {
        if (!token || !ids) return

        const fetchData = async () => {
            setLoading(true)
            setError(null)

            const args = [
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Authorization: `Bearer ${token}`
                    }
                }
            ]

            try {
                const customFetch = createSCAPIFetch(appConfig, 'store/shopper-stores', slotParams)
                const result = await customFetch('stores', 'GET', args)
                const htmlRes = await result.json()
                setResponse(htmlRes)
            } catch (err) {
                console.error('Error in fetching custom API:', err)
                setError(err.message || 'An unexpected error occurred')
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [token, slotParams, appConfig])

    return {response, loading, error}
}

export default useCustomFetch
